export default function SortableTh({
  label,
  active,
  direction,
  onClick,
  className = '',
  style,
}: {
  label: string;
  active: boolean;
  direction: 'asc' | 'desc';
  onClick: () => void;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <th className={`cursor-pointer select-none hover:text-mbc-soft ${className}`} style={style} onClick={onClick}>
      {label} {active ? (direction === 'desc' ? '↓' : '↑') : '↕'}
    </th>
  );
}
